import BreadCrumb from "Common/BreadCrumb";
import { PaginationState } from "@tanstack/react-table";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import { MoreHorizontal, Eye, FileEdit, Trash2 } from "lucide-react";
import { Dropdown } from "Common/Components/Dropdown";
import { Download, Plus, Search, SlidersHorizontal } from "lucide-react";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Flatpickr from "react-flatpickr";
import DeleteModal from "Common/DeleteModal";
import callApi from "Common/utils/apiCaller";
import { Pencil } from "lucide-react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import _ from "lodash";
import Drawer from "Common/Components/Drawer";
import { X } from "lucide-react";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import PermissionSwitch from "Common/Components/PermissionLocks/PermissionSwitch";
import { showNotification } from "Common/utils/Notification";
import LoaderComponent from "Common/Components/Loader/Loader";

const Editableviews = () => {
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
    })
  );

  const { permission } = useSelector(selectProperties);
  const [adminData, setAdminData] = useState([]);
  const [search, setSearch] = useState<any>();
  const [loader, setLoader] = useState<any>(false);
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);
  const [slugData, setSlugData] = useState<any>("");
  const [selectedImage, setSelectedImage] = useState<any>();
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const debouncedHandler = useCallback(
    _.debounce((user: any, render: any, pagination: any) => {
      return fetchDateWithFilters(user, render, pagination);
    }, 700),
    []
  );
  async function fetchDateWithFilters(
    searchByName: any,
    render: any,
    pagination: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }

    const localData = await callApi("v1/editableview/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    let arr = [];
    if (localData.status === "Success") {
      setAdminData([...localData.data.editableviewList]);
      setPageCount(
        Math.ceil(localData.data.editableviewCount / pagination.pageSize)
      );
      setTotalItems(localData.data.editableviewCount);
    }
  }

  interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");
  const premissionInfo: PermissionInfo | null = rawPermission
  ? JSON.parse(rawPermission)
  : null;

  const filterSearchData = (e: any) => {
    const search = e.target.value;

    setSearch(search);
  };

  useEffect(() => {
    debouncedHandler(search, render, pagination);
  }, [search, render, pagination]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));
      try {
        const res = await callApi(
          `v1/editableview/${eventData?._id}/remove`,
          "post",
          {}
        );
        if (res && res?.status === "Success") {
          setDeleteModal(false);
          setRender(!render);
          showNotification("Deleted successfully", "success");
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    }
  };
  //

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setSlugData(ele?.slug);
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (eventData && eventData.name) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),

    onSubmit: async (values) => {
      if (isEdit) {
        const updateData = {
          _id: eventData ? eventData._id : 0,
          ...values,
        };
        // update user
        if (!slugData) {
          showNotification("Please enter slug", "error");
          return;
        }
        try {
          setLoader(true);
          const res = await callApi(
            `v1/editableview/${eventData?._id}/update`,
            "post",
            {
              editableview: { ...values, slug: slugData },
            }
          );
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            showNotification("Updated successfully", "success");
          }
        } catch (e) {
          setLoader(false);
          showNotification("something went wrong", "error");
        }
        // dispatch(onUpdateEmployee(updateData));
      } else {
        try {
          setLoader(true);
          const res = await callApi(`v1/editableview/new`, "post", {
            editableview: {
              name: values?.name,
              //slug: values?.slug?.trim(),
            },
          });
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("editableview created successfully");
          }
        } catch (e) {
          setLoader(false);
          toast("something went wrong");
        }
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setSlugData("");
      setSelectedImage("");
    } else {
      setShow(true);
      setEventData("");
      setSlugData("");
      setSelectedImage("");
      validation.resetForm();
    }
  }, [show, validation]);

  const adminListColumns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Slug",
        accessorKey: "slug",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Edit",
        accessorKey: "edit",
        cell: ({ cell }: any) => (
          <PermissionSwitch
             hasPermissions={premissionInfo?.permissions ?? []}
            shouldHavePermissions={["editable:edit"]}
            yes={
              <button
                className="text-blue-500 hover:text-blue-700"
                onClick={() => {
                  const data = cell.row.original;
                  handleUpdateDataClick(data);
                }}
              >
                Edit
              </button>
            }
            no={<span></span>}
          />
        ),
      },
      {
        header: "Delete ",
        accessorKey: "delete",
        cell: ({ cell }: any) => (
          <PermissionSwitch
             hasPermissions={premissionInfo?.permissions ?? []}
            shouldHavePermissions={["editable:delete"]}
            yes={
              <button
                className="text-red-500 hover:text-red-700"
                onClick={() => {
                  const data = cell.row.original;
                  onClickDelete(data);
                }}
              >
                Delete
              </button>
            }
            no={<span></span>}
          />
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Editableviews" pageTitle="Editableviews" version="" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="card-body">
            <div className="flex items-center">
              <h6 className="text-15 grow">Editableviews</h6>
              <div className="shrink-0">
                <PermissionSwitch
                   hasPermissions={premissionInfo?.permissions ?? []}
                  shouldHavePermissions={["editable:create"]}
                  yes={
                    <button
                      type="button"
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={toggle}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Editableviews</span>
                    </button>
                  }
                  no={
                    <button
                      type="button"
                      disabled={true}
                      className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={null}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Editableviews</span>
                    </button>
                  }
                />
              </div>
            </div>
          </div>
          <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
            <form action="#!">
              <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                <div className="relative xl:col-span-3">
                  <input
                    type="text"
                    className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Search for name..."
                    autoComplete="off"
                    onChange={(e) => filterSearchData(e)}
                  />
                  <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                </div>
              </div>
            </form>
          </div>
          <div className="card-body">
            <TableContainer
              isPagination={true}
              columns={adminListColumns || []}
              data={adminData || []}
              pageCount={pageCount}
              pagination={pagination}
              totalItems={totalItems}
              onPaginationChange={(updater: any) => {
                const nextState = updater(pagination);
                if (nextState.pageIndex !== pagination.pageIndex)
                  setPagination(nextState);
              }}
              divclassName="overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            />
          </div>
        </div>
      </div>
      {/* Employee Modal */}
      <Drawer
        show={show}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {!!isEdit ? "Edit Editableview" : "Add Editableview"}
          </Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <input type="hidden" value="" name="id" id="id" />
            <input type="hidden" value="add" name="action" id="action" />
            <input type="hidden" id="id-field" />
            <div
              id="alert-error-msg"
              className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
            ></div>
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-12">
                <label
                  htmlFor="phoneNumberInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="phoneNumberInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter editableview Name"
                  name="name"
                  onChange={validation.handleChange}
                  value={validation.values.name || ""}
                />
                {validation.touched.name && validation.errors.name ? (
                  <p className="text-red-400">{validation.errors.name}</p>
                ) : null}
              </div>
              {!!isEdit ? (
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInpute"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Slug
                  </label>
                  <input
                    type="text"
                    id="locationInpute"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Slug"
                    onChange={(e) => setSlugData(e.target.value)}
                    value={slugData || ""}
                  />
                </div>
              ) : null}
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                id="close-modal"
                data-modal-close="addEmployeeModal"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="addNew"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? (
                  <LoaderComponent />
                ) : !!isEdit ? (
                  "Update Editableview"
                ) : (
                  "Add Editableview"
                )}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>
    </React.Fragment>
  );
};

export default Editableviews;
